<div class="d-print-flex">
  <mat-form-field
    [ngClass]="{
      hilite: hilite,
      'no-subscript': noSubscript && !control.invalid,
    }"
  >
    <mat-label>{{ placeholder }}</mat-label>
    <mat-chip-grid #resourceChips [formControl]="control">
      <mat-chip-row
        *ngFor="let resource of selectedResources"
        [selectable]="true"
        [removable]="!resource?.disabled && !disabled"
        (removed)="remove(resource)"
        [ngClass]="{
          auto: resource?.insertOrigin == insertOrigin.Auto,
        }"
      >
        {{ resource?.name }}
        <mat-icon matChipRemove *ngIf="!disabled && !resource?.disabled"
          >cancel</mat-icon
        >
      </mat-chip-row>
      <input
        #resourceInput
        [matAutocomplete]="resourceAutocomplete"
        [matChipInputFor]="resourceChips"
        [matChipInputAddOnBlur]="false"
        [placeholder]="placeholder"
        (keyup)="onKeyUp($event)"
        (blur)="clearInvalidText()"
        [formControl]="inputCtrl"
      />
    </mat-chip-grid>
    <mat-autocomplete
      #resourceAutocomplete="matAutocomplete"
      (optionSelected)="selected($event)"
    >
      <mat-optgroup
        *ngFor="let group of resourceGroups"
        [label]="group.name"
        [ngClass]="{ accelerator: group.type == 15 }"
      >
        <mat-option
          *ngFor="let item of group.items"
          [value]="item.resource"
          [ngClass]="{
            'parent-option': item.level === 0,
            'child-option': item.level === 1,
          }"
        >
          {{ item.resource.name }}
        </mat-option>
      </mat-optgroup>
    </mat-autocomplete>

    <mat-error *ngIf="control.invalid">{{ getErrorMsg(control) }}</mat-error>
  </mat-form-field>
</div>
